import React from 'react'
import { ReactComponent as Logo } from '../images/cluster-logo.svg'
import { ReactComponent as ReclusterIcon } from '../images/recluster.svg'

import styles from './LoadScreen.module.scss';

export default function LoadScreen() {

  return (
    <div className={styles.wrapper}>
      <Logo className={styles.logo} />

      <div className={styles.message}><ReclusterIcon className={styles.spinner} /> Loading...</div>
    </div>
  )
}